/* unplugin-vue-components disabled */import __unplugin_components_0 from 'C:/Users/will/workspace/risesun/zhxy/EvaluateJYJPC/src/components/SvgIcon/index.vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "logo_box_css"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "center_box_css"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0,
  style: {
    "float": "right"
  }
};
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import useUserStore from "@/store/modules/user";
import yzm from "@/components/yzm/index.vue";
export default {
  __name: 'login',
  setup(__props) {
    const userStore = useUserStore();
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const loginForm = ref({
      username: "",
      password: "",
      rememberMe: false,
      code: "",
      uuid: ""
    });
    const validateCode = ref(null);
    const codeRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入验证码"));
      } else if (value.toUpperCase() != validateCode.value?.codeString?.toUpperCase()) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    const loginRules = {
      username: [{
        required: true,
        trigger: "blur",
        message: "请输入您的账号"
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: "请输入您的密码"
      }],
      code: [{
        validator: codeRule,
        trigger: "blur"
      }]
    };
    const codeUrl = ref("");
    const loading = ref(false);
    // 验证码开关
    const captchaOnOff = ref(true);
    // 注册开关
    const register = ref(false);
    const redirect = ref(undefined);
    function handleLogin() {
      proxy.$refs.loginRef.validate(valid => {
        if (valid) {
          loading.value = true;
          // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
          if (loginForm.value.rememberMe) {
            Cookies.set("username", loginForm.value.username, {
              expires: 30
            });
            Cookies.set("password", encrypt(loginForm.value.password), {
              expires: 30
            });
            Cookies.set("rememberMe", loginForm.value.rememberMe, {
              expires: 30
            });
          } else {
            // 否则移除
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          // 调用action的登录方法
          userStore.login(loginForm.value).then(() => {
            router.push({
              path: redirect.value || "/"
            });
          }).catch(() => {
            loading.value = false;
            // 重新获取验证码
          });
        }
      });
    }
    function getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      loginForm.value = {
        username: username === undefined ? loginForm.value.username : username,
        password: password === undefined ? loginForm.value.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    }
    getCookie();
    return (_ctx, _cache) => {
      const _component_svg_icon = __unplugin_components_0;
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: require('@/assets/images/login/sunrise-logo.png'),
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: require('@/assets/images/login/text.png'),
        alt: ""
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: "img_box_css",
        src: require('@/assets/images/login/loginbj.png'),
        alt: ""
      }, null, 8, _hoisted_6), _createVNode(_component_el_form, {
        ref: "loginRef",
        model: _unref(loginForm),
        rules: loginRules,
        class: "login-form"
      }, {
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("h3", {
          class: "title"
        }, "欢迎登录湖口县校本作业资源平台", -1)), _createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(loginForm).username = $event),
            type: "text",
            size: "large",
            "auto-complete": "off",
            placeholder: "账号"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "user",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(loginForm).password = $event),
            type: "password",
            size: "large",
            "auto-complete": "off",
            placeholder: "密码",
            onKeyup: _withKeys(handleLogin, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "password",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _unref(captchaOnOff) ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: "code",
          class: "yzm_css_box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).code,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(loginForm).code = $event),
            size: "large",
            "auto-complete": "off",
            placeholder: "验证码",
            style: {
              "width": "62%"
            },
            onKeyup: _withKeys(handleLogin, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "validCode",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(yzm, {
            ref_key: "validateCode",
            ref: validateCode
          }, null, 512)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_checkbox, {
          modelValue: _unref(loginForm).rememberMe,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(loginForm).rememberMe = $event),
          style: {
            "margin": "0px 0px 25px 0px"
          }
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("记住密码", -1)]))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: _unref(loading),
            size: "large",
            type: "primary",
            style: {
              "width": "100%"
            },
            onClick: _withModifiers(handleLogin, ["prevent"])
          }, {
            default: _withCtx(() => [!_unref(loading) ? (_openBlock(), _createElementBlock("span", _hoisted_7, "登 录")) : (_openBlock(), _createElementBlock("span", _hoisted_8, "登 录 中..."))]),
            _: 1
          }, 8, ["loading"]), _unref(register) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_router_link, {
            class: "link-type",
            to: '/register'
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("立即注册", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "el-login-footer"
      }, [_createElementVNode("span", null, "技术支持热线: 400-833-2878                                CopyRight@ 2023 江西升阳软件技术有限公司")], -1))]);
    };
  }
};